// Module
var code = " <div id=\"optionOrganisationSelector\"> <div class=\"level :whenNoOrganisation\"> <div class=\"level-left\"> <div class=\"level-item\"> <label class=\"label\"> Entity to show: </label> </div> </div> </div> <div class=\"fixed-grid has-1-cols\"> <div class=\"grid\" id=\"optionsEntities\"> </div> </div> </div> ";
// Exports
export default code;